module.exports = __webpack_public_path__ + "static/media/hold-triangle-1.144c89e9.svg";